import * as Schema from "effect/Schema";
import { IsoDateTime, ThreadId, TrimmedNonEmptyString } from "./baseSchemas";

export const ThreadDevRuntimeStatus = Schema.Literals(["idle", "allocated", "running", "released"]);
export type ThreadDevRuntimeStatus = typeof ThreadDevRuntimeStatus.Type;

export const ThreadDevRuntimeRecord = Schema.Struct({
  threadId: ThreadId,
  allocatedPort: Schema.Number,
  terminalId: Schema.optional(TrimmedNonEmptyString),
  status: ThreadDevRuntimeStatus,
  previewUrl: Schema.optional(TrimmedNonEmptyString),
  tunnelId: Schema.optional(TrimmedNonEmptyString),
  updatedAt: IsoDateTime,
});
export type ThreadDevRuntimeRecord = typeof ThreadDevRuntimeRecord.Type;

export const ThreadDevRuntimeGetInput = Schema.Struct({
  threadId: ThreadId,
});
export type ThreadDevRuntimeGetInput = typeof ThreadDevRuntimeGetInput.Type;

export const ThreadDevRuntimeAllocatePortInput = Schema.Struct({
  threadId: ThreadId,
});
export type ThreadDevRuntimeAllocatePortInput = typeof ThreadDevRuntimeAllocatePortInput.Type;

export const ThreadDevRuntimeReleaseInput = Schema.Struct({
  threadId: ThreadId,
});
export type ThreadDevRuntimeReleaseInput = typeof ThreadDevRuntimeReleaseInput.Type;

export class ThreadDevRuntimeError extends Schema.TaggedErrorClass<ThreadDevRuntimeError>()(
  "ThreadDevRuntimeError",
  {
    detail: TrimmedNonEmptyString,
  },
) {}
